export const BankTransactionStatusCommand = {
  setStatusHandled: '0',
  setStatusUnhandled: '1',
  setStatusIngored: '2',
};
